module.exports = __webpack_public_path__ + "static/media/vtex7.b4541127.png";